import React from "react";

import Select from "react-select";
import _ from "lodash";

function SelectFormField({
  error,
  label,
  value,
  name,
  options,
  isMulti = false,
  onChange = null,
  objectValue = false,
}) {
  return (
    <>
      <label className="form-label fw-medium mb-1">{label}</label>
      {error && <div className="form-error small mb-1">{error}</div>}
      <Select
        name={name}
        defaultValue={value}
        getOptionLabel={(item) => item.name}
        getOptionValue={(item) => {
          if (objectValue) return item;
          if (item.id) return item.id;
          return item.name;
        }}
        options={_.filter(
          options,
          (p) =>
            _.findIndex(value, (item) => {
              if (item.id) return item.id === p.id;
              return p.name.toLowerCase() === value.name.toLowerCase();
            }) === -1
        )}
        isMulti={isMulti}
        onChange={onChange}
      />
    </>
  );
}

export default SelectFormField;
